import { useTranslation } from "react-i18next";
import { Button } from "components/common/Button";
import type { RoomsMergeBarProps } from "./types";

const MIN_MERGED_ROOMS = 2;

export const RoomsMergeBar = ({
  selectedCount,
  name,
  isMerging,
  onNameChange,
  onCancel,
  onMerge,
}: RoomsMergeBarProps) => {
  const { t } = useTranslation();

  const canMerge =
    selectedCount >= MIN_MERGED_ROOMS && name.trim() !== "" && !isMerging;

  return (
    <div className="flex flex-col gap-2 p-3 rounded-md border border-blue-400 bg-white">
      <input
        type="text"
        value={name}
        placeholder={t("smartSurveyor.rooms.namePlaceholder")}
        aria-label={t("smartSurveyor.rooms.nameLabel")}
        maxLength={120}
        onChange={(event) => onNameChange(event.target.value)}
        className="w-full rounded-md border border-gray-300 bg-white px-2 py-1 text-sm text-gray-900 outline-none focus:border-blue-500"
      />
      <div className="flex gap-2">
        <Button className="flex-1" onClick={onCancel} disabled={isMerging}>
          {t("common.cancel")}
        </Button>
        <Button
          variant="primary"
          className="flex-1"
          onClick={onMerge}
          disabled={!canMerge}
        >
          {isMerging
            ? t("smartSurveyor.rooms.merging")
            : t("smartSurveyor.rooms.merge", { selectedCount })}
        </Button>
      </div>
    </div>
  );
};
